module.exports = __webpack_public_path__ + "img/jxjqrc.a68c4e3b.png";